import PropTypes from 'prop-types';

import './Spinner.css';
import { buildClass } from '../../libs/classes';

/**
 * Simple spinner representing loading status
 * @component
 */
export const Spinner = ({ className }) => {
	return <div className={buildClass('spinner', className)} />;
};

Spinner.propTypes = {
	// Additional class
	className: PropTypes.string,
};

export default Spinner;
